/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_DescriptionInputs */

const en_newsletter_archive_description = /** @type {(inputs: Newsletter_Archive_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product updates, release notes, and the occasional behind-the-scenes. Every issue lives here.`)
};

/**
* | output |
* | --- |
* | "Product updates, release notes, and the occasional behind-the-scenes. Every issue lives here." |
*
* @param {Newsletter_Archive_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_description = /** @type {((inputs?: Newsletter_Archive_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_description(inputs)
});